module.exports = __webpack_public_path__ + "static/media/popup_error.5336d5d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popup_error.svg
// module id = 510
// module chunks = 0